import React from 'react';

import LicensePlateSolidIcon from '../../../../../../shared/icons/license-plate-solid-icon';
import VinSolidIcon from '../../../../../../shared/icons/vin-solid-icon';
import Button from '../../../../../button/button';
import FitmentAddVehicleOptionsButton from '../fitment-add-vehicle-options-button/fitment-add-vehicle-options-button';

import './fitment-add-vehicle-options.scss';

interface FitmentAddVehicleOptionsProps {
  handleAddNewVehicleOptionsButton: () => void;
  handleNoLicenseAndVinButton: () => void;
}

function FitmentAddVehicleOptions(props: FitmentAddVehicleOptionsProps) {
  const { handleAddNewVehicleOptionsButton, handleNoLicenseAndVinButton } =
    props;

  return (
    <div data-testid="fitment-add-vehicle-options" styleName="container">
      <div
        data-testid="search-buttons-container"
        styleName="search-buttons-container"
      >
        <FitmentAddVehicleOptionsButton
          icon={<LicensePlateSolidIcon />}
          onClick={handleAddNewVehicleOptionsButton}
          searchBy="License Plate"
        />
        <FitmentAddVehicleOptionsButton
          icon={<VinSolidIcon />}
          searchBy="VIN"
        />
      </div>
      <Button
        data-testid="no-license-btn"
        onClick={handleNoLicenseAndVinButton}
        styleName="no-license-btn"
      >
        I don&#39;t have a license plate or VIN
      </Button>
    </div>
  );
}

export default FitmentAddVehicleOptions;
